import { useState } from 'react'
import { Modal, TextField, BlockStack, Text, Link } from '@shopify/polaris'
import { adminUrl } from '../lib/admin-url'

type Props = {
    open: boolean
    email: string
    phone: string
    customerId: string
    onSave: (email: string, phone: string) => void
    onClose: () => void
}

export function EditContactModal({ open, email: initialEmail, phone: initialPhone, customerId, onSave, onClose }: Props) {
    const [email, setEmail] = useState(initialEmail)
    const [phone, setPhone] = useState(initialPhone)
    const [emailError, setEmailError] = useState('')

    const handleDone = () => {
        if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            setEmailError('Enter a valid email address')
            return
        }
        setEmailError('')
        onSave(email, phone)
        onClose()
    }

    const handleEmailChange = (value: string) => {
        setEmail(value)
        if (emailError) setEmailError('')
    }

    return (
        <Modal
            open={open}
            onClose={onClose}
            title="Edit contact information"
            primaryAction={{ content: 'Done', onAction: handleDone }}
            secondaryActions={[{ content: 'Cancel', onAction: onClose }]}
        >
            <Modal.Section>
                <BlockStack gap="400">
                    <TextField label="Email" value={email} onChange={handleEmailChange} autoComplete="email" error={emailError} />
                    <TextField label="Phone number" value={phone} onChange={setPhone} autoComplete="tel" />
                    <Text as="p" tone="subdued" variant="bodySm">
                        Changes here will only be applied to this order. To update this information on new orders, edit the contact information on the{' '}
                        <Link url={adminUrl(`customers/${customerId}`)} target="_blank">customer page</Link>.
                    </Text>
                </BlockStack>
            </Modal.Section>
        </Modal>
    )
}
